import styled from 'styled-components/macro';

import { bounce } from 'components/common/animations';
import * as colors from '../common/colorConstants';

export const Wrapper = styled.div`
  position: relative;
  animation-name: scrollOpen;
  animation-duration: 1s;
  animation-direction: forwards;

  @keyframes scrollOpen {
    0% {
      opacity: 0;
      height: 0px;
    }

    90% {
      opacity: 0;
      height: 40px;
    }

    100% {
      opacity: 1;
    }
  }
`;

export const IncomingChatIcon = styled.div`
  background-color: ${colors.blue1};
  margin: 10px auto 0px auto;
  padding: 4px 5px 4px 8px;
  width: 50px;
  height: 30px;
  position: relative;
  cursor: pointer;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  font-family: 'Roboto Condensed', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  color: ${colors.lightGray21};
  border-radius: 5px;
  transition: 0.7s;
  animation-delay: 1.3s;
  ${bounce}
`;

export const InnerIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const NominatedChatPopupWrapper = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: absolute;
  right: -360px;
  top: 0px;
`;
